import type { ConversationMessage } from '@quromedical/communication';
import { useCallback, useMemo } from 'react';
import { strings } from 'strings';
import { trpc } from 'trpc';

type useCommunicationsProps = {
  conversations: ConversationMessage[];
  error: string | undefined;
  isLoading: boolean;
  refetch: () => Promise<void>;
};

export const useCommunications = (
  patientId: string,
  nextOfKinId?: string,
): useCommunicationsProps => {
  const {
    data,
    isLoading: loading,
    error: trpcError,
    refetch,
    isRefetching,
  } = trpc.communication.conversation.getAll.useQuery(
    {
      subject: patientId,
      nextOfKin: nextOfKinId,
    },
    {
      staleTime: 60000,
    },
  );

  const refetchConversations = useCallback(async () => {
    await refetch();
  }, [refetch]);

  const conversations = useMemo(() => data?.conversations || [], [data]);
  const error = trpcError ? strings.GenericErrorMessage : undefined;
  const isLoading = loading || isRefetching;

  return { conversations, isLoading, error, refetch: refetchConversations };
};
